import Deliberation from "./Deliberation";

export default Deliberation;
